import { render, staticRenderFns } from "./SalesLeadOrigin.vue?vue&type=template&id=9d8e4744&"
import script from "./SalesLeadOrigin.vue?vue&type=script&lang=js&"
export * from "./SalesLeadOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports